/**
 * @generated SignedSource<<ada5cae6f90ef499f72cb51e51bfeba0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Avatar_connectActor$data = {
  readonly employee: {
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"Avatar_employee">;
  } | null;
  readonly " $fragmentType": "Avatar_connectActor";
};
export type Avatar_connectActor$key = {
  readonly " $data"?: Avatar_connectActor$data;
  readonly " $fragmentSpreads": FragmentRefs<"Avatar_connectActor">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Avatar_connectActor",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Employee",
      "kind": "LinkedField",
      "name": "employee",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Avatar_employee"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ConnectActor",
  "abstractKey": null
};

(node as any).hash = "365150e549964acc68dcb4d3986bbb13";

export default node;
